import { render, staticRenderFns } from "./chapterDetails.vue?vue&type=template&id=baf75074&"
import script from "./chapterDetails.vue?vue&type=script&lang=js&"
export * from "./chapterDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports